import {
  BestMixFeed,
  ScenarioFeedProgram,
  ManualFeed,
} from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-feed-program.type';
import { FeedProgramForm } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-feed-program-form.type';
import { Feed } from 'views/bluviu-nutrition/types/feed.type';

const CURRENCY_PER_UNIT_LABELS: Record<string, string> = {
  nokPerKg: 'NOK/kg',
  usdPerKg: 'USD/kg',
  usdPerLbs: 'USD/lb',
};

/**
 * Uses Typescript's Type Predicate to define the type of a feed at runtime.
 * https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
 * @param feed
 * @returns
 */
export const isBestMixFeed = (feed: ManualFeed | BestMixFeed): feed is BestMixFeed => {
  return (feed as BestMixFeed).productCode !== undefined;
};

export const combinedFeeds = (manualFeeds: ManualFeed[], bestMixFeeds: BestMixFeed[]): (ManualFeed | BestMixFeed)[] => {
  return [...manualFeeds, ...bestMixFeeds].sort((a, b) => a.fishSizeStart - b.fishSizeStart);
};

/**
 * Maps saved FeedProgram data back to FeedProgramForm[] by resolving ManualFeed/BestMixFeed
 * identifiers to full Feed objects from the feeds catalog.
 */
export const mapFeedProgramsToForm = (feedPrograms: ScenarioFeedProgram[], feeds: Feed[]): FeedProgramForm[] => {
  return feedPrograms.map((program) => {
    const combined = combinedFeeds(program.manualFeeds, program.bestMixFeeds);

    return {
      name: program.name,
      rows: combined.map((item) => {
        const feedId = isBestMixFeed(item) ? item.productCode : item.feedId;
        const matchedFeed = feeds.find((f) => f.id === feedId) ?? null;

        return {
          feed: matchedFeed,
          startFeedingAtFishSize: item.fishSizeStart,
          price: item.price,
        };
      }),
    };
  });
};

export const formatCurrencyPerUnit = (currencyPerUnit?: string): string => {
  if (!currencyPerUnit) return '';
  return CURRENCY_PER_UNIT_LABELS[currencyPerUnit] ?? currencyPerUnit;
};
